import {PushNotifications} from '@capacitor/push-notifications';

export const addListeners = async () => {
    await PushNotifications.addListener('registration', token => {
        //console.info('Registration token: ', token.value);
    });

    await PushNotifications.addListener('registrationError', err => {
        //console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
        
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        
    });
}

export const registerNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions!');
    }

    await PushNotifications.register();
}

export const getDeliveredNotifications = async () => {
    const notificationList = await PushNotifications.getDeliveredNotifications();
}